import { siteInfo } from "@/mocks/dramas";

const PRINCIPLES = [
  {
    icon: "ri-eye-line",
    title: "只推荐真正看过的剧",
    text: "每一部进入榜单的作品都由编辑完整看过，写清推荐理由与适合人群，不做未经核实的转发。",
  },
  {
    icon: "ri-scales-3-line",
    title: "评分有统一标准",
    text: "从剧情完成度、节奏紧凑度、表演与制作水准三个维度打分，同一标准横向比较，避免凭个人喜好排序。",
  },
  {
    icon: "ri-refresh-line",
    title: "榜单持续维护",
    text: "热度榜与口碑榜每日更新，新剧上线后 24 小时内补录，让榜单始终反映当下的真实情况。",
  },
  {
    icon: "ri-shield-check-line",
    title: "不夸大不误导",
    text: "不用夸张标题博取点击，剧集信息以实际内容为准，描述与正片不符的作品会及时调整或下架。",
  },
];

export default function Principles() {
  return (
    <section className="py-16 md:py-20" aria-labelledby="principle-title">
      <div className="mx-auto max-w-page px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.85fr_1.15fr]">
          <div>
            <span className="text-xs font-label tracking-[0.3em] text-primary-400">网站定位与内容原则</span>
            <h2 id="principle-title" className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              我们想做一个挑片效率更高的地方
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              短剧数量增长很快，但信息却很零散：评分口径不一、简介常年不更新、同类型作品散落各处。
              {siteInfo.name} 想解决的，正是「想找一部对味的剧，却要翻很久」这件事。
            </p>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              所以我们把重点放在两件事上：一是把榜单做扎实，二是把「同款类似」这件事讲清楚。
              只要这两点做到位，你就不需要再靠猜来选片。
            </p>
            <div className="mt-8 rounded-lg border border-accent-500/30 bg-accent-100/20 p-5">
              <p className="flex items-start gap-3 text-sm leading-relaxed text-foreground-800">
                <i className="ri-compass-3-line mt-0.5 text-xl text-accent-400" aria-hidden="true"></i>
                我们的发展理念很简单：内容优先、口径统一、持续更新。不追热点排序，不为了流量牺牲可信度。
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
            {PRINCIPLES.map((item) => (
              <article
                key={item.title}
                className="rounded-lg border border-background-200/70 bg-background-100/60 p-6 transition-colors hover:border-primary-400/60"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-100 text-accent-400">
                  <i className={`${item.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{item.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.text}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}